var styleDataHash = '89aad244';  
export const injectCss = (() => {
  var css = `.ugKFX{transform:rotate(0)}.UUtR0{transform:rotate(90deg)}.BA-8g{transform:rotate(180deg)}.x61pJ{transform:rotate(270deg)}.y9s1b{margin:5px}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "thumbnailPlacementSelector_BOTTOM": "ugKFX",
  "thumbnailPlacementSelector_LEFT": "UUtR0",
  "thumbnailPlacementSelector_TOP": "BA-8g",
  "thumbnailPlacementSelector_RIGHT": "x61pJ",
  "thumbnailPlacementSelector": "y9s1b"
};